module.exports = __webpack_public_path__ + "img/user-circle-solid.7a2bc244.svg";